const SettingsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 33.434 33.43"
      className="fill-current"
    >
      <path
        id="Path_12179"
        data-name="Path 12179"
        d="M33.175,21.221,29.6,18.693a12.9,12.9,0,0,0-.02-4.1l3.542-2.562a.614.614,0,0,0,.224-.686c-.166-.513-.336-.973-.517-1.406s-.392-.875-.643-1.354a.614.614,0,0,0-.544-.329.623.623,0,0,0-.1.009L27.232,9a12.9,12.9,0,0,0-2.915-2.881L25.009,1.8a.614.614,0,0,0-.327-.644A17.57,17.57,0,0,0,21.907.026a.612.612,0,0,0-.683.231L18.695,3.83a12.651,12.651,0,0,0-4.1.02L12.034.308a.613.613,0,0,0-.686-.224C10.833.251,10.373.42,9.942.6s-.874.392-1.353.643a.614.614,0,0,0-.32.647L9.007,6.2A12.907,12.907,0,0,0,6.126,9.115L1.8,8.423a.6.6,0,0,0-.1-.008.614.614,0,0,0-.546.334A17.633,17.633,0,0,0,.028,11.525a.613.613,0,0,0,.231.683l3.573,2.529a12.9,12.9,0,0,0,.019,4.1L.31,21.4a.614.614,0,0,0-.224.687c.167.515.336.975.517,1.406s.392.875.643,1.353a.616.616,0,0,0,.648.32L6.2,24.425a12.9,12.9,0,0,0,2.916,2.881l-.692,4.322a.614.614,0,0,0,.327.644A17.618,17.618,0,0,0,11.527,33.4a.613.613,0,0,0,.683-.231L14.739,29.6a12.91,12.91,0,0,0,4.1-.019L21.4,33.122a.614.614,0,0,0,.687.224c.515-.167.975-.336,1.406-.517s.875-.392,1.353-.643a.614.614,0,0,0,.32-.648l-.739-4.308a12.914,12.914,0,0,0,2.881-2.915l4.322.692a.612.612,0,0,0,.644-.327,17.625,17.625,0,0,0,1.132-2.78.614.614,0,0,0-.231-.683m-22.16-2.108a6.186,6.186,0,1,1,8.1,3.3,6.186,6.186,0,0,1-8.1-3.3"
        transform="translate(0 0.002)"
      />
    </svg>
  )
}

export default SettingsIcon
